import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useRequestDescriptor } from '../request-view/useRequest';
import { evaluatePath } from '../request-view/request-descriptor';
export function RequestLine({ disabled }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const [request] = useRequestDescriptor();
    const path = ((_a = request.url) === null || _a === void 0 ? void 0 : _a.path) && ((_b = request.url) === null || _b === void 0 ? void 0 : _b.parameters)
        ? evaluatePath(request.url.path, request.url.parameters)
        : (_c = request.url) === null || _c === void 0 ? void 0 : _c.path;
    return (_jsxs("div", { "data-slot": "control", className: clsx([
            // Basic layout
            'relative flex w-full',
            // Background color + shadow applied to inset pseudo element, so shadow blends with border in light mode
            'before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow',
            // Background color is moved to control and shadow is removed in dark mode so hide `before` pseudo
            'dark:before:hidden',
            // Focus ring
            'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset after:ring-transparent sm:after:focus-within:ring-2 sm:after:focus-within:ring-blue-500',
            // Disabled state
            'disabled:opacity-50 before:disabled:bg-zinc-950/5 before:disabled:shadow-none',
            // Invalid state
            'before:invalid:shadow-red-500/10'
        ]), children: [_jsx("span", { className: clsx([
                    // Basic layout
                    'relative inline-flex appearance-none rounded-l-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
                    // Typography
                    'text-base/6 text-zinc-950 sm:text-sm/6 dark:text-white',
                    // Border
                    'border border-zinc-950/10 dark:border-white/10',
                    // Background color
                    'bg-transparent dark:bg-white/5'
                ]), children: (_e = (_d = request.method) === null || _d === void 0 ? void 0 : _d.toUpperCase()) !== null && _e !== void 0 ? _e : 'GET' }), _jsxs("div", { className: clsx([
                    // Basic layout
                    'relative flex inline-flex w-full items-center rounded-r-lg',
                    // Border
                    'border-b border-l-0 border-r border-t border-zinc-950/10 dark:border-white/10',
                    // Background color
                    'bg-transparent dark:bg-white/5',
                    // Invalid state
                    'invalid:border-red-500 invalid:dark:border-red-500',
                    // Disabled state
                    'disabled-within:border-zinc-950/20 disabled-within:dark:bg-white/[2.5%] disabled-within:dark:border-white/15'
                ]), children: [((_f = request.url) === null || _f === void 0 ? void 0 : _f.base) && (_jsx("span", { className: clsx([
                            // Basic layout
                            'relative inline-flex select-none appearance-none items-center py-[calc(theme(spacing[2.5])-1px)] pl-[calc(theme(spacing[3.5])-1px)] pr-0 sm:py-[calc(theme(spacing[1.5])-1px)] sm:pl-[calc(theme(spacing[3])-1px)]',
                            // Typography
                            'text-base/6 text-zinc-500 sm:text-sm/6',
                            // Hide default focus styles
                            'focus:outline-none'
                        ]), children: request.url.base.toString() })), _jsx("input", { type: "text", name: "url", id: "url", disabled: disabled || ((_g = request.url) === null || _g === void 0 ? void 0 : _g.parameters) !== undefined, className: clsx([
                            // Basic layout
                            'relative inline-flex w-full appearance-none  py-[calc(theme(spacing[2.5])-1px)]  sm:py-[calc(theme(spacing[1.5])-1px)]',
                            ((_h = request.url) === null || _h === void 0 ? void 0 : _h.base)
                                ? 'pl-1 pr-[calc(theme(spacing[3.5])-1px)] sm:pr-[calc(theme(spacing[3])-1px)]'
                                : 'px-[calc(theme(spacing[3.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)]',
                            // Typography
                            'text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6 dark:text-white',
                            // Border
                            'border-0',
                            // Background color
                            'bg-transparent',
                            // Hide default focus styles
                            'focus:outline-none'
                        ]), value: path, placeholder: (_j = request.url) === null || _j === void 0 ? void 0 : _j.path })] })] }));
}
